import { 
    LOGIN_RESULT, 
    MATCH_STARTED, 
    NUM_PLAYERS_CHANGED, 
    BET_STARTED, 
    BET_PLACED, 
    BET_FINISHED, 
    QUESTION_ASKED, 
    ASK_FINISHED, 
    RECEIVE_QUESTIONS, 
    RECEIVE_ANSWERS, 
    SAVED_QUESTION, 
    SAVED_ANSWER, 
    DELETED_ANSWER, 
    DELETED_QUESTION,
    SAVED_MATCH,
    RECEIVE_MATCHES,
    DELETED_MATCH,
    MATCH_STOPPED,
    ANSWER_GIVEN,
    CHART_UPDATED,
    POSITION_UPDATED,
    UNKNOWN_TOKEN,
    RECEIVED_CHAT_MESSAGE,
    RECEIVE_QUESTION_GAME,
    RECEIVE_BETS,
    RECEIVE_USER_POINTS,
    CHANGED_USER_POINTS,
    BEEN_MODERATED,
    PLAYER_MODERATED,
    PLAYER_ADDED,
    PLAYER_REMOVED,
    BANNED_PLAYERS_SENT,
    STREAMING_STARTED, 
    LOGGED_OUT,
    EXP_USER_RECEIVED,
    USER_CALLED, 
    CALL_CONFIRMED, 
    CALL_CLOSED, 
    CALL_REFUSED,
    SAVED_EXP_USER,
    USER_LOGGED_IN,
    USER_LOGGED_OUT,
    RECEIVE_CURRENTQUESTIONID,
    RECEIVE_USERANSWERS,
    RECEIVE_QUESTION_GAMES,
    CHAT_ENABLED,
    CHAT_DISABLED, 
    SAVED_NEW_USERNAME,
    USER_DELETED,
    PASSWORD_UPDATED,
    AUTOSTREAM_STARTED,
    AUTOSTREAM_STOPPED,
    NUMBER_OF_CHATTERS_SENT,
    NUMBER_OF_CHATTERS_SETTED,
    USERS_LIMIT_NUMBER_SENT,
    USERS_LIMIT_NUMBER_SETTED,
    GAME_RESTORED,
    SNAPSHOT_DELETED,
    TEMPORARY_USER_DELETED
} from '../events/ServerToClient'
import { 
    loginResult, 
    numPlayersChanged, 
    betStarted, 
    betPlaced, 
    betFinished, 
    questionAsked, 
    askFinished, 
    receiveQuestions, 
    receiveAnswers, 
    savedQuestion, 
    receiveQuestionGame,
    savedAnswer, 
    deletedAnswer,
    deletedQuestion,
    answerGiven,
    ANSWER_PROCESSED,
    answerProcessed, 
    beenModerated,
    playerModerated,
    playerAdded,
    playerRemoved,
    streamingStarted,
    STREAMING_STOPPED,
    streamingStopped,
    receiveUsers,
    receiveExpUser,
    userCalled,
    callConfirmed,
    callClosed,
    callRefused,
    receiveBets,
    receiveUserPoints,
    changedUserPoints,
    userLoggedIn,
    userLoggedOut,
    receiveCurrentQuestionId,
    receiveUserAnswers,
    receiveQuestionGames,
    chatEnabled,
    chatDisabled,
    passwordUpdated,
    autostreamStarted,
    autostreamStopped,
    numberOfChattersSetted,
    numberOfChattersSent,
    usersLimitNumberSent,
    usersLimitNumberSetted,
    gameRestored,
    snapshotDeleted,
    temporaryUserDeleted
} from '../reducers/actions'

import { positionUpdated, loggedOut, userDeleted } from '../reducers/user/actions'
import { savedMatch, receiveMatches, deletedMatch, startedMatch, stoppedMatch } from '../reducers/matches'
import { chartUpdated } from '../reducers/chart';
import { socketConnected, socketDisconnected } from '../reducers/connected'
import { RECONNECT } from '../events/ClientToServer'
import { receivedChatMessage } from '../reducers/chatMessages';
import {bannedPlayersSent} from '../reducers/bannedplayers'
import { USERS_RECEIVED, savedExpUser, savedNewUsername } from '../reducers/users';
import {startTheCall, closeTheCall} from '../utils/CallSystem'
import { startTheStream, closeTheStream } from '../utils/VideoStream';

export default (    store) => {
    const { socket } = store.getState()

    socket.on('connect', () => {
        store.dispatch(socketConnected())
        const { currentToken } = store.getState()
        if (currentToken)
            socket.emit(RECONNECT, { token: currentToken })
    })
    socket.on('disconnect', () => store.dispatch(socketDisconnected()))

    socket.on(LOGIN_RESULT, (user) => store.dispatch(loginResult(user)))
    socket.on(MATCH_STARTED, (match) => store.dispatch(startedMatch(match)))
    socket.on(MATCH_STOPPED, (match) => store.dispatch(stoppedMatch(match)))
    socket.on(NUM_PLAYERS_CHANGED, ({ onlinePlayers, numPlayers }) => store.dispatch(numPlayersChanged({ onlinePlayers, numPlayers })))
    socket.on(BET_STARTED, (game_id, question, betMs, start_bet_date, currentQuestionIndex) => store.dispatch(betStarted(game_id, question, betMs, start_bet_date, currentQuestionIndex)))
    socket.on(BET_PLACED, ({ game_id, user_id,  bet, question_id, balance, old_balance }) => store.dispatch(betPlaced({game_id, question_id, user_id, bet, balance, old_balance})))
    socket.on(BET_FINISHED, ( game_id, question_id,  end_bet_date ) => store.dispatch(betFinished(game_id ,question_id, end_bet_date)))
    socket.on(QUESTION_ASKED, (game_id, question, ms, ask_date, currentQuestionIndex) => store.dispatch(questionAsked(game_id, question, ms, ask_date, currentQuestionIndex)))
    socket.on(ASK_FINISHED, (game_id, question_id, end_ask_date, userAnswersCount ) => store.dispatch(askFinished(game_id, question_id, end_ask_date, userAnswersCount)))
    socket.on(RECEIVE_QUESTIONS, (questions) => store.dispatch(receiveQuestions(questions)))
    socket.on(RECEIVE_ANSWERS, ({ answers }) => store.dispatch(receiveAnswers(answers)))
    socket.on(RECEIVE_QUESTION_GAME, ({ question_game} ) => store.dispatch(receiveQuestionGame(question_game)))
    socket.on(SAVED_QUESTION, ({ question, prevId }) => store.dispatch(savedQuestion(question, prevId)))
    socket.on(SAVED_ANSWER, ({ answer, prevId }) => store.dispatch(savedAnswer(answer, prevId)))
    socket.on(DELETED_ANSWER, ({ answer }) => store.dispatch(deletedAnswer(answer)))
    socket.on(DELETED_QUESTION, ({ question }) => store.dispatch(deletedQuestion(question)))
    socket.on(SAVED_MATCH, ({ match, prevId, question_game, password }) => store.dispatch(savedMatch(match, prevId, question_game, password)))
    socket.on(RECEIVE_MATCHES, ({ matches }) =>  store.dispatch(receiveMatches(matches)))
    socket.on(DELETED_MATCH, ( {match} ) => store.dispatch(deletedMatch(match)))
    socket.on(ANSWER_GIVEN, ({ userAnswer }) => store.dispatch(answerGiven(userAnswer)))
    socket.on(ANSWER_PROCESSED, (game_id, { userAnswer, user_id }) => store.dispatch(answerProcessed(game_id, userAnswer, user_id)))
    socket.on(CHART_UPDATED, ({ chart, match }) => store.dispatch(chartUpdated(chart, match)))
    socket.on(POSITION_UPDATED, ({ user_id, position, numPlayers, balance }) => store.dispatch(positionUpdated(user_id, position, numPlayers, balance)))
    socket.on(UNKNOWN_TOKEN, () => window.location.reload())
    socket.on(RECEIVED_CHAT_MESSAGE, ({ message }) => store.dispatch(receivedChatMessage(message)))
    socket.on(BEEN_MODERATED, ({ user_id }) => store.dispatch(beenModerated({user_id})))
    socket.on(PLAYER_MODERATED,({user}) => store.dispatch(playerModerated(user)))
    socket.on(PLAYER_ADDED,({user_id}) => store.dispatch(playerAdded(user_id)))
    socket.on(PLAYER_REMOVED,({user_id}) => store.dispatch(playerRemoved(user_id)))
    socket.on(BANNED_PLAYERS_SENT,({players}) => store.dispatch(bannedPlayersSent(players)))
    socket.on(STREAMING_STARTED,({live_video_url})=> store.dispatch(streamingStarted(live_video_url)))
    socket.on(STREAMING_STOPPED,()=> store.dispatch(streamingStopped()))
    socket.on(LOGGED_OUT,(user)=> store.dispatch(loggedOut(user)))
    socket.on(USER_LOGGED_IN,(user)=> store.dispatch(userLoggedIn(user)))
    socket.on(USER_LOGGED_OUT,(user)=> store.dispatch(userLoggedOut(user)))
    socket.on(USERS_RECEIVED,({users})=> store.dispatch(receiveUsers({users})))
    socket.on(EXP_USER_RECEIVED,(exp_user)=> store.dispatch(receiveExpUser(exp_user)))
    socket.on(PASSWORD_UPDATED,({user_id})=> store.dispatch(passwordUpdated(user_id)))
    socket.on(USER_DELETED,({user_id})=> store.dispatch(userDeleted(user_id)))
    socket.on(SAVED_EXP_USER,({exp_user, user_id})=> store.dispatch(savedExpUser(exp_user, user_id)))
    socket.on(SAVED_NEW_USERNAME,({username, user_id})=> store.dispatch(savedNewUsername(username, user_id)))
    socket.on(RECEIVE_BETS,({bets, user_id})=> store.dispatch(receiveBets(bets, user_id)))
    socket.on(RECEIVE_USER_POINTS,({user_id, user_points})=> store.dispatch(receiveUserPoints(user_id, user_points)))
    socket.on(CHANGED_USER_POINTS,({user_id, balance})=> store.dispatch(changedUserPoints(user_id, balance)))
    socket.on(USER_CALLED,({user_id}) => store.dispatch(userCalled({user_id})))
    socket.on(CALL_CONFIRMED,({camera, microphone, user_id, host, result}) => {
            store.dispatch(callConfirmed({user_id, result}));
            startTheCall(camera,microphone,user_id, host);
        })
    socket.on(CALL_CLOSED,({user_id, result}) => {
            closeTheCall(user_id);
            store.dispatch(callClosed(user_id, result));
    })
    socket.on(RECEIVE_CURRENTQUESTIONID,({currentQuestionId}) => store.dispatch(receiveCurrentQuestionId(currentQuestionId)))
    socket.on(RECEIVE_USERANSWERS,({userAnswers, balance, user_id}) => store.dispatch(receiveUserAnswers(userAnswers, balance, user_id)))
    socket.on(RECEIVE_QUESTION_GAMES,({question_games}) => store.dispatch(receiveQuestionGames(question_games)))
    socket.on(CALL_REFUSED,({user_id, result}) => store.dispatch(callRefused({user_id, result})))
    socket.on(CHAT_ENABLED,() => store.dispatch(chatEnabled()))
    socket.on(CHAT_DISABLED,() => store.dispatch(chatDisabled()))
    socket.on(GAME_RESTORED,({game_id}) => store.dispatch(gameRestored(game_id)))
    socket.on(SNAPSHOT_DELETED,({game_id}) => store.dispatch(snapshotDeleted(game_id)))
    socket.on(TEMPORARY_USER_DELETED,() => store.dispatch(temporaryUserDeleted()))
    socket.on(NUMBER_OF_CHATTERS_SETTED,({numberOfChatters}) => store.dispatch(numberOfChattersSetted(numberOfChatters)))
    socket.on(NUMBER_OF_CHATTERS_SENT,({numberOfChatters}) => store.dispatch(numberOfChattersSent(numberOfChatters)))
    socket.on(USERS_LIMIT_NUMBER_SENT,({usersLimitNumber}) => store.dispatch(usersLimitNumberSent(usersLimitNumber)))
    socket.on(USERS_LIMIT_NUMBER_SETTED,({usersLimitNumber}) => store.dispatch(usersLimitNumberSetted(usersLimitNumber)))
    socket.on(AUTOSTREAM_STARTED,({camera,microphone, host})=> {
        startTheStream(camera,microphone,host)
        store.dispatch(autostreamStarted())
    })
    socket.on(AUTOSTREAM_STOPPED,() => {
        closeTheStream();
        store.dispatch(autostreamStopped())
    })
    
    
    // observeStore(store, state => state.user.isLogging, onLoggingChange)
}
     


// WEBPACK FOOTER //
// ./src/listeners/socket.js